<div class="page-container">
  <!-- Page Header -->
  <intelishs-page-header title="Empleados" subtitle="Gestion y administracion de personal" />

  <!-- Dos filtros que se combinan, y viven DENTRO de la tabla que acotan:
       - Estado, en la barra: tres opciones excluyentes son UN control, y uno o
         dos controles van en `filtros-barra` (regla del data-table).
       - «Les falta», en el panel plegable: es trabajo de limpieza, no de cada
         visita, y sus 13 chips empujaban la tabla debajo de la pantalla. El
         circular lleva `.is-activo` con un faltante aplicado: plegado, es la
         única pista de que la lista está acotada. -->
  <intelishs-data-table
    [data]="empleadosFiltrados()"
    [columns]="columns()"
    [loading]="loading()"
    [pageSize]="15"
    [pageSizeOptions]="[10, 15, 25, 50]"
    [(query)]="query"
    searchWidth="compact"
    searchPlaceholder="Nombre, ID, RFC, CURP, puesto o área…"
    [extraFilterKeys]="extraFilterKeys"
    [exportColumns]="exportColumns"
    [showAddButton]="true"
    (add)="nuevoEmpleado()"
    [showRefreshButton]="true"
    (refresh)="cargarEmpleados(true)"
    [showExportButton]="true"
    exportFilename="Empleados"
  >
    <!-- Cambia lo que se ve, así que son pestañas (`role="tab"`) y no radios:
         ver «Segmentado» en la skill sinay-frontend-ui. -->
    <div
      slot="filtros-barra"
      class="sinay-segmented sinay-segmented--compacto"
      role="tablist"
      aria-label="Estado"
    >
      @for (op of opcionesEstado(); track op.etiqueta) {
        <button
          type="button"
          role="tab"
          class="sinay-segment"
          [class.is-active]="estado() === op.valor"
          [attr.aria-selected]="estado() === op.valor"
          (click)="estado.set(op.valor)"
        >
          <span class="seg-text">{{ op.etiqueta }}</span>
          <span class="seg-conteo">{{ op.total }}</span>
        </button>
      }
    </div>

    <button
      slot="acciones"
      nz-button
      nzType="default"
      type="button"
      class="btn-refresh-circle"
      nz-tooltip
      [nzTooltipTitle]="tooltipPanel()"
      [attr.aria-label]="panelAbierto() ? 'Ocultar «Les falta»' : 'Mostrar «Les falta»'"
      [attr.aria-expanded]="panelAbierto()"
      [class.is-activo]="faltante() !== null"
      (click)="panelAbierto.set(!panelAbierto())"
    >
      <span nz-icon nzType="filter" nzTheme="outline"></span>
    </button>

    <!-- El div se proyecta SIEMPRE y el `@if` va dentro: cerrado queda vacío y
         el theme lo colapsa (`.sinay-panel-filtros:empty`). -->
    <div slot="filtros" class="sinay-panel-filtros">
      @if (panelAbierto()) {
        <div class="panel-faltan" role="group" aria-label="Les falta">
          <span class="panel-faltan__rotulo">Les falta</span>
          @if (chipsFaltantes().length) {
            <div class="chips-faltan__rejilla">
              @for (c of chipsFaltantes(); track c.campo) {
                <intelishs-stat-chip
                  color="orange"
                  [label]="c.etiqueta"
                  [value]="c.faltan"
                  [active]="faltante() === c.campo"
                  (select)="alternarFaltante(c.campo)"
                  nz-tooltip
                  [nzTooltipTitle]="tooltipChip(c)"
                />
              }
            </div>
          } @else {
            <p class="panel-faltan__vacio">Ningún expediente incompleto en esta vista.</p>
          }
        </div>
      }
    </div>

    <!-- Empleado: nombre arriba, "ID · puesto" como contexto -->
    <ng-template intelishsCellTemplate="nombreCompleto" let-row>
      <intelishs-cell-stack
        [main]="row.nombreCompleto"
        [meta]="row.idInterno + (row.puesto ? ' · ' + row.puesto : '')"
      />
    </ng-template>

    <!-- Área arriba, dirección como contexto (se trunca con tooltip) -->
    <ng-template intelishsCellTemplate="area" let-row>
      <intelishs-cell-stack [main]="row.area || '—'" [meta]="row.direccion || ''" />
    </ng-template>

    <!-- Cero es lo bueno y se pinta apagado: con el mismo peso que un 5,
         habría que leer el número para saber si hay problema. El tooltip dice
         CUÁLES faltan; sin él, «5» obliga a abrir el expediente. -->
    <ng-template intelishsCellTemplate="faltan" let-row>
      @if (row.faltan === 0) {
        <span class="faltan-cero" nz-tooltip nzTooltipTitle="Expediente completo">—</span>
      } @else {
        <span class="badge badge--celda faltan-badge" nz-tooltip [nzTooltipTitle]="queLeFalta(row)">
          {{ row.faltan }}
        </span>
      }
    </ng-template>

    <ng-template intelishsCellTemplate="acciones" let-row>
      <intelishs-table-actions
        [row]="row"
        [actions]="getActionsForRow(row)"
        (action)="onAction({ action: $event, row })"
      />
    </ng-template>
  </intelishs-data-table>

  <!-- Modal: cambio de área (DELETE+INSERT en relempleadodireccionarea) -->
  <app-cambiar-area-modal
    [(visible)]="cambiarAreaVisible"
    [empleado]="empleadoParaCambio()"
    (guardado)="onAreaCambiada()"
  />

  <!-- Modal: documentos del empleado (visual / sin backend hoy). Los archivos
       se manejan en memoria local del modal; la persistencia al FileManager
       API se conecta en otro pase cuando el catálogo del DBA esté listo. -->
  <app-documentos-modal [(visible)]="documentosVisible" [empleado]="empleadoParaDocs()" />
</div>
